export const validateId = (id: string) => {
  return /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(id);
};

export const validateEmail = (email: string) => {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const emailUpd = email.trim();
  let emailErr = null;

  if (emailUpd.length === 0) emailErr = 'Email address is required';
  else if (!emailRegex.test(emailUpd)) emailErr = 'Invalid email address';

  return { emailErr };
};
